import React, { useState } from "react";
import Button from "../../atoms/button/button";
import ModalConocerTalento from "../../molecules/modal-conocer-talento/modalConocerTalento";

// Styles //
import "./talentsSelected.scss";

const TalentsSelected = ({talentsSelectedIds,getTalentsValues, createDataLayerTags}) => {

    // Bloque creado para el modal //
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const closeModal = () => {
        document.body.style.overflow = "scroll";
        setIsOpenModal((setShow) => !setShow);
    };
    // Bloque creado para el modal //

    return (
        
        <div className="talent-selected" id="talentSelected">
            <h2>
                Tienes {talentsSelectedIds.length} {talentsSelectedIds.length > 1 ? 'talentos seleccionados' : 'talento seleccionado'}  
            
                <Button
                    onClickAction={() => {
                        setIsOpenModal(true);
                        getTalentsValues(talentsSelectedIds, true);
                        createDataLayerTags();
                    }}
                    type="button"
                    text={
                        `${talentsSelectedIds.length > 1
                        ? 'CONOCER TALENTOS'
                        : 'CONOCER TALENTO'}`
                    }
                    classname={`a-button__magenta`}
                    isDisabled={false}
                />
            </h2>
            {isOpenModal && (
                <ModalConocerTalento
                    showModal={isOpenModal} 
                    onClose={closeModal}
                    talentsSelectedIds={talentsSelectedIds.length} 
                />
            )}
        </div>
    );
};

export default TalentsSelected;
